"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Title = _interopRequireDefault(require("../../Title"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var SuccessIcon = require('@tencent/ixd-icons-react/dist').SuccessIcon;
function index(props) {
  var _a, _b;
  var style = props.style,
    flexTitle = props.flexTitle,
    description = props.description,
    _c = props.configuration,
    configuration = _c === void 0 ? [] : _c,
    _d = props.list,
    list = _d === void 0 ? [] : _d,
    tab = props.tab,
    title = props.title;
  var _e = (0, _react.useState)(0),
    active = _e[0],
    setActive = _e[1];
  var _f = (0, _react.useState)(configuration[0]),
    currentConfig = _f[0],
    setCurrentConfig = _f[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-container",
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, flexTitle && /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: description
  }), title && /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-small-title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-wrap",
    style: tab ? {
      marginBottom: 40
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('package-switch-main', {
      'orange-theme': (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.colorTheme) === 'orange'
    }),
    style: tab ? {
      marginLeft: 0,
      marginRight: 0
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-main-left"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-main-left-title"
  }, currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.leftTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-main-left-tab"
  }, list === null || list === void 0 ? void 0 : list.map(function (item, index) {
    var txt = item.txt,
      extendProps = item.extendProps;
    return /*#__PURE__*/_react["default"].createElement("div", __assign({
      className: (0, _classnames["default"])('package-switch-main-left-tab-item', {
        isActive: active === index,
        'orange-theme': (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.colorTheme) === 'orange'
      }),
      onClick: function onClick() {
        setActive(index);
        setCurrentConfig(configuration[index]);
      }
    }, extendProps || {}, {
      key: index
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "package-switch-main-left-tab-item-txt"
    }, txt));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-main-left-desc-list"
  }, (_a = currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.descList) === null || _a === void 0 ? void 0 : _a.map(function (item, index) {
    var desc = item.desc,
      isIcon = item.isIcon;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('package-switch-main-left-desc', {
        'orange-theme': (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.colorTheme) === 'orange'
      }),
      key: index
    }, isIcon ? /*#__PURE__*/_react["default"].createElement(SuccessIcon, null) : null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "package-switch-main-left-desc-content"
    }, desc));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-main-right"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('package-switch-main-right-title', {
      'orange-theme': (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.colorTheme) === 'orange'
    })
  }, currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.rightTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-main-right-desc"
  }, currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.rightDesc), /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-main-right-btn"
  }, /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('package-switch-main-right-btn-txt', {
      'orange-theme': (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.colorTheme) === 'orange'
    }),
    onClick: function onClick() {
      (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.onCallback) && (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.onCallback());
    }
  }, (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.extendProps) || {}), currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.btnTxt))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-wrap-mobile"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('package-switch-main-title-mobile', {
      'orange-theme': (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.colorTheme) === 'orange'
    })
  }, currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.rightTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-main-desc-mobile"
  }, currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.rightDesc), /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-main-tab-list-mobile"
  }, list === null || list === void 0 ? void 0 : list.map(function (item, index) {
    var txt = item.txt,
      extendProps = item.extendProps;
    return /*#__PURE__*/_react["default"].createElement("div", __assign({
      className: (0, _classnames["default"])('package-switch-main-tab-item-mo', {
        isActive: active === index,
        'orange-theme': (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.colorTheme) === 'orange'
      }),
      onClick: function onClick() {
        setActive(index);
        setCurrentConfig(configuration[index]);
      }
    }, extendProps || {}, {
      key: index
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "package-switch-main-tab-item-txt-mo"
    }, txt));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-main-desc-list-mobile"
  }, (_b = currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.descList) === null || _b === void 0 ? void 0 : _b.map(function (item, index) {
    var desc = item.desc,
      isIcon = item.isIcon;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('package-switch-main-desc-item-mobile', {
        'orange-theme': (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.colorTheme) === 'orange'
      }),
      key: index
    }, isIcon ? /*#__PURE__*/_react["default"].createElement(SuccessIcon, null) : null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "package-switch-main-desc-item-content-mobile"
    }, desc));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-switch-main-btn-mobile"
  }, /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('package-switch-main-btn-txt-mobile', {
      'orange-theme': (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.colorTheme) === 'orange'
    }),
    onClick: function onClick() {
      (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.onCallback) && (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.onCallback());
    }
  }, (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.extendProps) || {}), currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.btnTxt))));
}